var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1842 8.42582C29.1673 9.89712 29.1673 11.9453 29.1673 16.0416C29.1673 20.138 29.1673 22.1862 28.1842 23.6575C27.7586 24.2944 27.2118 24.8413 26.5748 25.2669C25.2895 26.1257 23.564 26.2343 20.4173 26.248V26.25L18.805 29.4746C18.2676 30.5494 16.7337 30.5494 16.1963 29.4746L14.584 26.25V26.248C11.4373 26.2343 9.7118 26.1257 8.42649 25.2669C7.78955 24.8413 7.24267 24.2944 6.81708 23.6575C5.83398 22.1862 5.83398 20.138 5.83398 16.0416C5.83398 11.9453 5.83398 9.89712 6.81708 8.42582C7.24267 7.78888 7.78955 7.242 8.42649 6.81641C9.8978 5.83331 11.946 5.83331 16.0423 5.83331H18.959C23.0553 5.83331 25.1035 5.83331 26.5748 6.81641C27.2118 7.242 27.7586 7.78888 28.1842 8.42582Z",
    stroke: "black",
    strokeOpacity: 0.67,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 13.125L21.875 13.125",
    stroke: "black",
    strokeOpacity: 0.67,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 18.9583H17.5",
    stroke: "black",
    strokeOpacity: 0.67,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.51b289c43d1b8368e828c96230c6f442.svg";
export { ForwardRef as ReactComponent };